import { userActions } from "actions";
import store from "store";
import { log } from "utils";

export function handleAPIResult(result, reject, wanted = 200) {
  if (result.status === 401) {
    store.dispatch(userActions.logout());
    reject(result.statusText);
  }

  // 403 pour pas permission

  if (result.status !== wanted) {
    var e = new Error(`(${result.statusText}) ${result.url}`);
    e.name = "APIError";
    log(e);
    reject(result.statusText);
  }
}
